import React, { Fragment, useState } from 'react';
import { Card, Row } from 'react-bootstrap';
import Crop169RoundedIcon from '@mui/icons-material/Crop169Rounded';
import Crop32RoundedIcon from '@mui/icons-material/Crop32Rounded';
import Crop54RoundedIcon from '@mui/icons-material/Crop54Rounded';
import CropDinRoundedIcon from '@mui/icons-material/CropDinRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import PanoramaWideAngleRoundedIcon from '@mui/icons-material/PanoramaWideAngleRounded';
import ActionButton from '../Reusable/ActionButton';
import CustomModal from '../Reusable/Modal/CustomModal';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import CustomButton from '../Reusable/CustomButton';

const PopupDemo = (props) => {
  const { gt } = props || {};
  const modalInitState = {
    small: false,
    medium: false,
    large: false,
    xl: false,
    wideModal: false,
    footer: false,
    draggable: false,
    removeRoundedEdges: false,
    centered: true,
    footerContent: null,
  };
  const [showModal, setShowModal] = useState(modalInitState);

  const onModalCloseHandler = () => {
    setShowModal(modalInitState);
  };

  const openModal =
    showModal.small ||
    showModal.medium ||
    showModal.large ||
    showModal.xl ||
    showModal.wideModal;
  const modalSize = () => {
    if (showModal.small === true) return 'sm';
    if (showModal.medium) return 'md';
    if (showModal.large) return 'lg';
    if (showModal.xl) return 'xl';
    return null;
  };

  const confirmActionHandler = () =>
    confirmDialog(
      'Da li zaista želite da izvršite ovu akciju?',
      () => console.log('action'),
      '',
      gt
    );

  const additionalFooterContent = () => {
    return (
      <CustomButton
        label={'Dugme'}
        onClick={confirmActionHandler}
        tooltipText={'Klikom na ovo dugme otvara se popup za potvrdu'}
        startIcon={<i className="fa-solid fa-xmark"></i>}
      />
    );
  };

  return (
    <Fragment>
      <Card className={`table-card-style`}>
        <Card.Header className="table-card-header-style">
          <Card.Title className="d-flex gap-3 align-items-center">
            Popup
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-center m-1">
            <ActionButton
              actionMessage="malih dimenzija"
              icon={<Crop169RoundedIcon style={{ fontSize: '3rem' }} />}
              action={() => setShowModal((prev) => ({ ...prev, small: true }))}
            />
            <ActionButton
              actionMessage="srednjih dimenzija"
              icon={<Crop32RoundedIcon style={{ fontSize: '3rem' }} />}
              action={() => setShowModal((prev) => ({ ...prev, medium: true }))}
            />
            <ActionButton
              actionMessage="velikih dimenzija"
              icon={<Crop54RoundedIcon style={{ fontSize: '3rem' }} />}
              action={() => setShowModal((prev) => ({ ...prev, large: true }))}
            />
            <ActionButton
              actionMessage="XL dimenzija"
              icon={<CropDinRoundedIcon style={{ fontSize: '3rem' }} />}
              action={() => setShowModal((prev) => ({ ...prev, xl: true }))}
            />
            <ActionButton
              actionMessage="XXL dimenzija"
              icon={
                <PanoramaWideAngleRoundedIcon style={{ fontSize: '3rem' }} />
              }
              action={() =>
                setShowModal((prev) => ({ ...prev, wideModal: true }))
              }
            />
            <ActionButton
              actionMessage="Potvrda akcije"
              icon={
                <TaskAltRoundedIcon
                  style={{ fontSize: '3rem', color: '#1dc4e9' }}
                />
              }
              action={confirmActionHandler}
            />
            <ActionButton
              actionMessage="Srednjih dimenzija draggable"
              icon={<Crop32RoundedIcon style={{ fontSize: '3rem' }} />}
              action={() =>
                setShowModal((prev) => ({
                  ...prev,
                  medium: true,
                  footer: true,
                  draggable: true,
                  removeRoundedEdges: true,
                  centered: false,
                }))
              }
            />
            <ActionButton
              actionMessage="XL custom footer"
              icon={<Crop32RoundedIcon style={{ fontSize: '3rem' }} />}
              action={() =>
                setShowModal((prev) => ({
                  ...prev,
                  xl: true,
                  footer: true,
                  removeRoundedEdges: true,
                  centered: false,
                  footerContent: additionalFooterContent,
                }))
              }
            />
          </Row>
        </Card.Body>
      </Card>
      {openModal && (
        <CustomModal
          show={openModal}
          hideModal={onModalCloseHandler}
          title={'Naslov'}
          modalSize={modalSize()}
          wideModal={showModal.wideModal}
          footer={showModal.footer}
          centered={showModal.centered}
          draggable={showModal.draggable}
          removeRoundedEdges={showModal.removeRoundedEdges}
          footerContent={showModal.footerContent}
        >
          <div>Sadržaj modala...</div>
        </CustomModal>
      )}
    </Fragment>
  );
};

export default PopupDemo;
